<!-- ============================================================== -->
<!-- Topbar header - style you can find in pages.scss -->
<!-- ============================================================== -->
<header class="topbar">
    <nav class="navbar top-navbar navbar-toggleable-sm navbar-light">
        <div class="navbar-collapse">
            <!-- ============================================================== -->
            <!-- toggle and nav items -->
            <!-- ============================================================== -->
            <ul class="navbar-nav mr-auto mt-md-0 ">
                <li class="nav-item d-md-none">
                    <div role="navigation">
                        <div id="menuToggle">
                            <i class="ion ion-md-menu smallIco white" (click)="menuToggle()"></i>
                            <div class="menuBg" [class.menuactive]="show">
                                <div id="menu">
                                    <i class="ion ion-md-close smallIco white" (click)="menuToggle()"></i>
                                    <ul class="topul">
                                        <li><a [routerLinkActiveOptions]="{exact: true}" (click)="menuToggle()" routerLinkActive="active" routerLink="/admin/solutions-list" class="white"><i class="ion ion-ios-arrow-forward medIco white"></i>Solutions</a></li>
                                        <li><a [routerLinkActiveOptions]="{exact: true}" (click)="menuToggle()" routerLinkActive="active" routerLink="/admin/suppliers-list" class="white"><i class="ion ion-ios-arrow-forward medIco white"></i>Suppliers</a></li>
                                        <li><a [routerLinkActiveOptions]="{exact: true}" (click)="menuToggle()" routerLinkActive="active" routerLink="/admin/generate-city-profile-link" class="white"><i class="ion ion-ios-arrow-forward medIco white"></i>Generate City Profile Link</a></li>
                                        <li><a [routerLinkActiveOptions]="{exact: true}" (click)="menuToggle()" routerLinkActive="active" routerLink="/admin/all-updates" class="white"><i class="ion ion-ios-arrow-forward medIco white"></i>All Updates</a></li>
                                    </ul>
                                </div>
                                <div class="menuOverlay" (click)="menuToggle()"></div>
                            </div>
                        </div>
                    </div>
                </li>
                <!-- This is  -->
                <li class="nav-item">
                    <!-- ============================================================== -->
                    <!-- Logo -->
                    <!-- ============================================================== -->
                    <div>
                        <a class="navbar-brand" [routerLink]="['/']">
                            <!-- Logo icon -->
                            <h1 class="titleHide">
                                <span>BRIGHT CITIES</span>
                                <!--You can put here icon as well // <i class="wi wi-sunset"></i> //-->
                                <!-- Dark Logo icon -->
                                <img src="../assets/images/logowhite-upgrade.svg" alt="homepage" class="dark-logo" />
                            </h1>
                            <!--End Logo icon -->
                        </a>
                    </div>
                    <!-- ============================================================== -->
                    <!-- End Logo -->
                    <!-- ============================================================== -->
                </li>

            </ul>
            <!-- ============================================================== -->
            <!-- User profile and search -->
            <!-- ============================================================== -->
            <ul class="navbar-nav my-lg-0" *ngIf="!loggedIn">
                <li class="nav-item">
                    <a [routerLink]="['/create-account']" class="btnWhite" [translate]="'navigation/register'">CREATE AN ACCOUNT</a>
                </li>
                <li class="nav-item">
                    <a [routerLink]="['/login']" class="nav-link" [translate]="'navigation/login'">Sign in</a>
                </li>
            </ul>
            <!-- ============================================================== -->
            <!-- User profile and search -->
            <!-- ============================================================== -->
            <div class="navbar-collapse" *ngIf="loggedIn">
                <!-- ============================================================== -->
                <!-- toggle and nav items -->
                <!-- ============================================================== -->
                <ul class="navbar-nav mr-auto mt-md-0 ">
                    <!-- This is  -->
                    <li class="nav-item"> </li>
                    <li class="nav-item"> </li>
                    <!-- ============================================================== -->
                    <!-- Comment -->
                    <!-- ============================================================== -->

                </ul>
                <!-- ============================================================== -->
                <!-- User profile -->
                <!-- ============================================================== -->
                <ul class="navbar-nav my-lg-0">
                    <li class="nav-item dropdown">
                        <a class="nav-link nav-link-username dropdown-toggle text-muted waves-effect waves-dark" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span class="titleHEader" [translate]="'navigation/control-panel'">Control Panel</span>
                        </a>
                    </li>
                    <li class="nav-item item dropdown">
                        <a class="nav-link nav-link-username dropdown-toggle text-muted waves-effect waves-dark" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span [innerHTML]="'navigation/hello' | translate:{value: user.firstName}">Hello, {{user.firstName}}</span>
                            <i class="ion-ios-arrow-down medIco white"></i>
                        </a>
                        <div class="dropdown-menu dropdown-menu-right animated flipInY dropdown-user-container">
                            <ul class="dropdown-user">
                                <!-- <li><a [routerLink]="['/smart-city-profile/']"><i class="ion ion-ios-arrow-forward branded02 medIco"></i><span class="dropdown-user-text">Your City</span></a></li> -->
                                <li><a (click)="logoutUser()"><i class="ion ion-ios-arrow-forward branded02 medIco"></i><span class="dropdown-user-text" [translate]="'navigation/sign-out'">Sign out</span></a></li>
                            </ul>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</header>
<!-- ============================================================== -->
<!-- End Topbar header -->
<!-- ============================================================== -->